var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", [
    _c("td", [_c("p", [_vm._v(_vm._s(_vm.team.name))])]),
    _vm._v(" "),
    _c(
      "td",
      [
        _c("student-indicator", {
          attrs: {
            student: _vm.team.leader,
            online: _vm.isStudentOnline(_vm.team.leader)
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("td", [
      _c("p", [_vm._v(_vm._s(_vm.team.students.length))]),
      _vm._v(" "),
      _vm.expanded
        ? _c(
            "ul",
            _vm._l(_vm.team.students, function(student) {
              return _c(
                "li",
                [
                  _c("student-indicator", {
                    attrs: {
                      student: student,
                      online: _vm.isStudentOnline(student)
                    }
                  })
                ],
                1
              )
            }),
            0
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "actions" }, [
      _c(
        "button",
        {
          on: {
            click: function($event) {
              _vm.$emit("electLeader", _vm.team)
              _vm.$refs["btn-elect-svg"].animate(
                [{ transform: "rotate(360deg)" }],
                { duration: 750, easing: "ease-in-out" }
              )
            }
          }
        },
        [
          _c("svg", { ref: "btn-elect-svg", staticClass: "icon icon_arrow" }, [
            _c("use", { attrs: { "xlink:href": "#icon_refresh" } })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          class: { expanded: _vm.expanded },
          on: {
            click: function($event) {
              _vm.expanded = !_vm.expanded
            }
          }
        },
        [
          _c("svg", { staticClass: "icon icon_dropdown" }, [
            _c("use", { attrs: { "xlink:href": "#icon_dropdown" } })
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }